<template>
  <div
    class="flex justify-content-center align-items-center"
    style="height: 80vh"
  >
    <h2 class="font-bold">Maaf, halaman tidak ditemukan.</h2>
  </div>
</template>
